export const BUTTON = 'inline-flex items-center justify-center text-nowrap';

export const BUTTON_L = `${BUTTON} h-52 sm:h-56 px-48`;
export const BUTTON_M = `${BUTTON} h-48 px-40`;
export const BUTTON_S = `${BUTTON} h-40 px-32`;
export const BUTTON_XS = `${BUTTON} h-40 px-16`;

export const SIZES = {
  l: BUTTON_L,
  m: BUTTON_M,
  s: BUTTON_S,
  xs: BUTTON_XS,
};

export const LABEL_TYPES: {
  l: 'button';
  m: 'button';
  s: 'link';
  xs: 'link';
} = {
  l: 'button',
  m: 'button',
  s: 'link',
  xs: 'link',
};
